import { heroImage } from '../data/copy'
import {
  HERO_QUALITY,
  HERO_SIZES,
  HERO_SRC_WIDTH,
  HERO_WIDTHS,
  optimizedImage,
  optimizedSrcSet,
} from './image'

const TITLE = 'FUTSAL 360 READY™ — The Visual Coaching System for Futsal Coaches'
const DESCRIPTION =
  'Plan your next futsal session in 5 minutes: 6 visual coaching volumes, 72 ready-to-run sessions, and 5 practical coaching bonuses.'

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

function appendLink(attrs: Record<string, string>): HTMLLinkElement {
  const link = document.createElement('link')
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value))
  document.head.appendChild(link)
  return link
}

/**
 * Prepara el <head> antes del primer render:
 *
 * - idioma, título y metadatos sociales (SEO / compartir);
 * - precarga de la imagen del hero, que es el elemento LCP.
 *
 * La tipografía de títulos (Barlow Condensed) se carga desde index.css; el
 * texto corrido usa la fuente del sistema para no descargar más archivos.
 */
export function setupHead(): void {
  if (typeof document === 'undefined') return

  document.documentElement.lang = 'en'
  document.title = TITLE

  upsertMeta('name', 'description', DESCRIPTION)
  // --color-ink, el fondo de la página
  upsertMeta('name', 'theme-color', '#0c0d0b')
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:title', TITLE)
  upsertMeta('property', 'og:description', DESCRIPTION)
  upsertMeta('property', 'og:image', heroImage)
  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', TITLE)
  upsertMeta('name', 'twitter:description', DESCRIPTION)
  upsertMeta('name', 'twitter:image', heroImage)

  if (document.head.querySelector('link[data-mp-head]')) return

  // Conexión anticipada al proxy de imágenes: ahorra DNS + TLS antes del LCP.
  appendLink({
    rel: 'preconnect',
    href: 'https://wsrv.nl',
    'data-mp-head': 'cdn',
  })

  // La imagen del hero es el LCP: se precarga en el mismo tamaño responsive
  // que usará el <img>, antes de que React monte.
  appendLink({
    rel: 'preload',
    as: 'image',
    href: optimizedImage(heroImage, HERO_SRC_WIDTH, HERO_QUALITY),
    imagesrcset: optimizedSrcSet(heroImage, HERO_WIDTHS, HERO_QUALITY),
    imagesizes: HERO_SIZES,
    fetchpriority: 'high',
    'data-mp-head': 'hero',
  })
}
